import React from 'react';
import { motion } from 'framer-motion';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .qe-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .qe-page { font-family: 'Inter', sans-serif; color: #0f172a; background: #ffffff; width: 100%; }

  /* ─── Hero ─────────────────────────────────────────────────── */
  .qe-hero { position: relative; padding: 100px 24px 120px; overflow: hidden; background: #fff; }
  .qe-hero-blob1 { position: absolute; top: -10%; right: -5%; width: 520px; height: 520px; border-radius: 50%; background: radial-gradient(circle, rgba(20,184,166,0.14), rgba(13,148,136,0.06)); filter: blur(80px); pointer-events: none; }
  .qe-hero-blob2 { position: absolute; bottom: -12%; left: -8%; width: 560px; height: 560px; border-radius: 50%; background: radial-gradient(circle, rgba(56,189,248,0.1), rgba(14,165,233,0.05)); filter: blur(90px); pointer-events: none; }
  .qe-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .qe-hero-inner { grid-template-columns: 1fr; } .qe-hero-visual { display: none; } }
  .qe-back-btn { display: inline-flex; align-items: center; gap: 6px; padding: 7px 16px; border-radius: 999px; border: 1px solid #e2e8f0; background: #fff; color: #475569; font-size: 12px; font-weight: 600; cursor: pointer; transition: all 0.18s ease; margin-bottom: 24px; }
  .qe-back-btn:hover { background: #f0fdfa; border-color: #99f6e4; color: #0d9488; }
  .qe-hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 16px; border-radius: 999px; background: #f0fdfa; border: 1px solid #99f6e4; font-size: 13px; font-weight: 500; color: #134e4a; margin-bottom: 28px; }
  .qe-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: #14b8a6; display: inline-block; animation: qe-pulse 2s infinite; }
  @keyframes qe-pulse { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(20,184,166,0.4);}50%{opacity:.85;box-shadow:0 0 0 6px rgba(20,184,166,0);} }
  .qe-hero h1 { font-size: clamp(1.8rem, 3.75vw, 3rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0f172a; margin-bottom: 24px; }
  .qe-gradient-text { background: linear-gradient(135deg, #0d9488, #0ea5e9); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .qe-hero p { font-size: 1.15rem; color: #475569; line-height: 1.75; margin-bottom: 40px; font-weight: 300; max-width: 520px; }
  .qe-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .qe-btn-primary { padding: 14px 28px; background: #0f172a; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: all 0.2s; }
  .qe-btn-primary:hover { background: #0d9488; box-shadow: 0 8px 24px rgba(13,148,136,0.35); transform: translateY(-1px); }
  .qe-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1.5px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .qe-btn-secondary:hover { border-color: #99f6e4; background: #f0fdfa; color: #134e4a; }

  /* Hero Visual */
  .qe-hero-visual { background: #fff; border-radius: 28px; border: 1px solid #e2e8f0; padding: 32px; box-shadow: 0 24px 64px rgba(13,148,136,0.07); }
  .qe-vis-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; padding-bottom: 18px; border-bottom: 1px solid #f1f5f9; }
  .qe-vis-title p:first-child { font-size: 11px; color: #94a3b8; font-weight: 600; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 3px; }
  .qe-vis-title p:last-child { font-size: 17px; font-weight: 800; color: #0f172a; }
  .qe-vis-icon { width: 46px; height: 46px; background: linear-gradient(135deg, #0d9488, #14b8a6); border-radius: 13px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
  .qe-schedule { display: flex; flex-direction: column; gap: 10px; margin-bottom: 18px; }
  .qe-schedule-item { display: flex; align-items: center; gap: 12px; padding: 13px 14px; border-radius: 11px; border: 1px solid; }
  .qe-schedule-item.paid { background: #f0fdfa; border-color: #99f6e4; }
  .qe-schedule-item.due { background: #fefce8; border-color: #fef08a; }
  .qe-schedule-item.upcoming { background: #f8fafc; border-color: #f1f5f9; }
  .qe-q-badge { width: 36px; height: 36px; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 800; flex-shrink: 0; }
  .qe-q-badge.paid { background: #0d9488; color: #fff; }
  .qe-q-badge.due { background: #ca8a04; color: #fff; }
  .qe-q-badge.upcoming { background: #e2e8f0; color: #475569; }
  .qe-sch-content { flex: 1; }
  .qe-sch-title { font-size: 13px; font-weight: 700; color: #334155; }
  .qe-sch-date { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .qe-sch-amount { font-size: 13px; font-weight: 800; }
  .qe-sch-amount.paid { color: #0d9488; }
  .qe-sch-amount.due { color: #ca8a04; }
  .qe-sch-amount.upcoming { color: #94a3b8; }
  .qe-vis-total { padding: 14px 16px; background: #0f172a; border-radius: 12px; display: flex; justify-content: space-between; align-items: center; }
  .qe-vis-total span:first-child { font-size: 13px; color: #94a3b8; }
  .qe-vis-total span:last-child { font-size: 16px; font-weight: 900; color: #5eead4; }

  /* ─── Stats ─────────────────────────────────────────────────── */
  .qe-stats { border-top: 1px solid #f1f5f9; border-bottom: 1px solid #f1f5f9; }
  .qe-stats-grid { display: grid; grid-template-columns: repeat(4,1fr); max-width: 1200px; margin: 0 auto; }
  @media (max-width: 768px) { .qe-stats-grid { grid-template-columns: repeat(2,1fr); } }
  .qe-stat { padding: 36px 24px; text-align: center; border-right: 1px solid #f1f5f9; }
  .qe-stat:last-child { border-right: none; }
  @media (max-width: 768px) { .qe-stat:nth-child(2n){ border-right:none; } .qe-stat{ border-bottom:1px solid #f1f5f9; } }
  .qe-stat-num { font-size: 2.2rem; font-weight: 900; letter-spacing: -0.03em; line-height: 1; margin-bottom: 8px; color: #0d9488; }
  .qe-stat-num.dark { color: #0f172a; }
  .qe-stat-label { font-size: 0.82rem; color: #64748b; font-weight: 500; }

  /* ─── Section Base ───────────────────────────────────────────── */
  .qe-section { padding: 96px 24px; }
  .qe-container { max-width: 1200px; margin: 0 auto; }
  .qe-section-header { text-align: center; max-width: 700px; margin: 0 auto 64px; }
  .qe-section-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .qe-section-header p { font-size: 1.05rem; color: #64748b; line-height: 1.75; }
  .qe-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #0d9488; margin-bottom: 12px; }

  /* ─── Who Needs Estimates ────────────────────────────────────── */
  .qe-who { background: #f8fafc; }
  .qe-who-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 24px; }
  @media (max-width: 900px) { .qe-who-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px) { .qe-who-grid { grid-template-columns: 1fr; } }
  .qe-who-card { background: #fff; border-radius: 20px; border: 1px solid #e2e8f0; padding: 30px; transition: all 0.3s; }
  .qe-who-card:hover { box-shadow: 0 16px 48px rgba(0,0,0,0.08); transform: translateY(-3px); border-color: #99f6e4; }
  .qe-who-icon { font-size: 28px; margin-bottom: 16px; display: block; }
  .qe-who-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 10px; }
  .qe-who-card p { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── Deadline Calendar ──────────────────────────────────────── */
  .qe-calendar { background: #fff; }
  .qe-cal-inner { background: #0f172a; border-radius: 32px; padding: 80px 64px; position: relative; overflow: hidden; }
  @media (max-width: 900px) { .qe-cal-inner { padding: 48px 32px; } }
  .qe-cal-glow1 { position: absolute; top: 0; right: 0; width: 400px; height: 400px; background: radial-gradient(circle, rgba(20,184,166,0.2), transparent 70%); pointer-events: none; }
  .qe-cal-glow2 { position: absolute; bottom: 0; left: 0; width: 350px; height: 350px; background: radial-gradient(circle, rgba(14,165,233,0.12), transparent 70%); pointer-events: none; }
  .qe-cal-header { text-align: center; margin-bottom: 56px; position: relative; z-index: 1; }
  .qe-cal-header .qe-label { color: #5eead4; }
  .qe-cal-header h2 { font-size: clamp(1.8rem, 3.5vw, 2.8rem); font-weight: 800; color: #fff; letter-spacing: -0.02em; }
  .qe-cal-header p { font-size: 1.05rem; color: #94a3b8; margin-top: 16px; line-height: 1.7; }
  .qe-deadlines { display: grid; grid-template-columns: repeat(4,1fr); gap: 20px; position: relative; z-index: 1; }
  @media (max-width: 900px) { .qe-deadlines { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 500px) { .qe-deadlines { grid-template-columns: 1fr; } }
  .qe-deadline-card { background: rgba(30,41,59,0.5); border: 1px solid rgba(71,85,105,0.4); border-radius: 20px; padding: 26px; transition: border-color 0.3s; }
  .qe-deadline-card:hover { border-color: rgba(20,184,166,0.5); }
  .qe-dl-quarter { font-size: 11px; font-weight: 700; color: #5eead4; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 8px; }
  .qe-dl-period { font-size: 14px; font-weight: 700; color: #f1f5f9; margin-bottom: 16px; }
  .qe-dl-date { font-size: 1.6rem; font-weight: 900; color: #fff; margin-bottom: 12px; letter-spacing: -0.02em; }
  .qe-dl-desc { font-size: 12px; color: #94a3b8; line-height: 1.55; }

  /* ─── Safe Harbor ─────────────────────────────────────────────── */
  .qe-safeharbor { background: #f8fafc; }
  .qe-sh-inner { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
  @media (max-width: 900px) { .qe-sh-inner { grid-template-columns: 1fr; gap: 48px; } }
  .qe-sh-left h2 { font-size: clamp(1.8rem, 3.5vw, 2.6rem); font-weight: 800; color: #0f172a; letter-spacing: -0.02em; margin-bottom: 16px; line-height: 1.2; }
  .qe-sh-left > p { font-size: 1.05rem; color: #64748b; line-height: 1.75; margin-bottom: 36px; }
  .qe-sh-options { display: flex; flex-direction: column; gap: 16px; }
  .qe-sh-option { padding: 20px 22px; background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; transition: all 0.2s; }
  .qe-sh-option:hover { border-color: #99f6e4; background: #f0fdfa; }
  .qe-sh-option h4 { font-size: 14px; font-weight: 700; color: #1e293b; margin-bottom: 6px; }
  .qe-sh-option p { font-size: 13px; color: #64748b; line-height: 1.6; }
  .qe-sh-option .qe-sh-tag { display: inline-block; margin-top: 10px; padding: 3px 10px; background: #f0fdfa; color: #0d9488; border-radius: 999px; font-size: 11px; font-weight: 700; }
  .qe-sh-visual { background: #fff; border: 1px solid #e2e8f0; border-radius: 24px; padding: 36px; box-shadow: 0 20px 60px rgba(0,0,0,0.06); }
  .qe-sh-vis-title { font-size: 15px; font-weight: 800; color: #0f172a; margin-bottom: 24px; }
  .qe-penalty-example { background: #fff7ed; border: 1px solid #fed7aa; border-radius: 14px; padding: 18px; margin-bottom: 16px; }
  .qe-penalty-example p:first-child { font-size: 12px; font-weight: 700; color: #b45309; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px; }
  .qe-penalty-example p:last-child { font-size: 13px; color: #92400e; line-height: 1.6; }
  .qe-no-penalty { background: #f0fdf4; border: 1px solid #d1fae5; border-radius: 14px; padding: 18px; margin-bottom: 24px; }
  .qe-no-penalty p:first-child { font-size: 12px; font-weight: 700; color: #059669; text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px; }
  .qe-no-penalty p:last-child { font-size: 13px; color: #065f46; line-height: 1.6; }
  .qe-sh-checklist { display: flex; flex-direction: column; gap: 10px; }
  .qe-sh-check { display: flex; align-items: center; gap: 10px; font-size: 13px; color: #374151; font-weight: 500; }
  .qe-sh-check-mark { width: 20px; height: 20px; border-radius: 50%; background: #d1fae5; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; color: #059669; flex-shrink: 0; }

  /* ─── How We Calculate ───────────────────────────────────────── */
  .qe-calculate { background: #fff; }
  .qe-calc-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }
  @media (max-width: 768px) { .qe-calc-grid { grid-template-columns: 1fr; } }
  .qe-calc-card { background: #f8fafc; border: 1px solid #f1f5f9; border-radius: 20px; padding: 28px; display: flex; gap: 20px; align-items: flex-start; transition: all 0.3s; }
  .qe-calc-card:hover { background: #fff; border-color: #99f6e4; box-shadow: 0 12px 40px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .qe-calc-emoji { font-size: 28px; flex-shrink: 0; margin-top: 2px; }
  .qe-calc-card h3 { font-size: 1.05rem; font-weight: 700; color: #1e293b; margin-bottom: 8px; }
  .qe-calc-card p { font-size: 0.9rem; color: #64748b; line-height: 1.65; }

  /* ─── FAQ ───────────────────────────────────────────────────── */
  .qe-faq { background: #f8fafc; }
  .qe-faq-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 18px; }
  @media (max-width: 768px) { .qe-faq-grid { grid-template-columns: 1fr; } }
  .qe-faq-item { background: #fff; border: 1px solid #e2e8f0; border-radius: 16px; padding: 26px; transition: all 0.2s; }
  .qe-faq-item:hover { border-color: #99f6e4; box-shadow: 0 4px 16px rgba(0,0,0,0.05); }
  .qe-faq-q { font-size: 0.98rem; font-weight: 700; color: #0f172a; margin-bottom: 10px; display: flex; gap: 10px; align-items: flex-start; }
  .qe-faq-q-icon { width: 22px; height: 22px; border-radius: 6px; background: #f0fdfa; display: flex; align-items: center; justify-content: center; font-size: 12px; color: #0d9488; flex-shrink: 0; margin-top: 1px; }
  .qe-faq-a { font-size: 0.9rem; color: #64748b; line-height: 1.7; }

  /* ─── CTA ────────────────────────────────────────────────────── */
  .qe-cta { background: #fff; border-top: 1px solid #f1f5f9; padding: 96px 24px; }
  .qe-cta-inner { background: #0f172a; border-radius: 32px; padding: 80px 48px; text-align: center; position: relative; overflow: hidden; max-width: 1000px; margin: 0 auto; }
  @media (max-width: 600px) { .qe-cta-inner { padding: 48px 24px; } }
  .qe-cta-glow1 { position: absolute; top: 0; right: 0; width: 360px; height: 360px; background: radial-gradient(circle, rgba(20,184,166,0.22), transparent 70%); pointer-events: none; }
  .qe-cta-glow2 { position: absolute; bottom: 0; left: 0; width: 300px; height: 300px; background: radial-gradient(circle, rgba(14,165,233,0.15), transparent 70%); pointer-events: none; }
  .qe-cta-inner h2 { font-size: clamp(2rem,4vw,3rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 20px; position: relative; z-index: 1; }
  .qe-cta-inner p { font-size: 1.1rem; color: #94a3b8; font-weight: 300; max-width: 540px; margin: 0 auto 40px; line-height: 1.75; position: relative; z-index: 1; }
  .qe-cta-btns { display: flex; gap: 16px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; margin-bottom: 36px; }
  .qe-cta-primary { padding: 16px 32px; background: linear-gradient(135deg, #0d9488, #14b8a6); color: #fff; border: none; border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; box-shadow: 0 4px 20px rgba(13,148,136,0.4); }
  .qe-cta-primary:hover { transform: translateY(-1px); box-shadow: 0 8px 28px rgba(13,148,136,0.5); }
  .qe-cta-secondary { padding: 16px 32px; background: rgba(255,255,255,0.06); color: #fff; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 16px; font-weight: 700; cursor: pointer; transition: all 0.2s; }
  .qe-cta-secondary:hover { background: rgba(255,255,255,0.1); }
  .qe-cta-badges { display: flex; gap: 24px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .qe-cta-badge { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #94a3b8; }
  .qe-cta-badge-check { color: #5eead4; }
`;

const fadeIn = { initial:{opacity:0,y:28}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-50px'}, transition:{duration:0.55} };
const stagger = (i:number) => ({ initial:{opacity:0,y:24}, whileInView:{opacity:1,y:0}, viewport:{once:true,margin:'-40px'}, transition:{duration:0.5,delay:i*0.1} });

const whoNeeds = [
  { icon:'💼', title:'Self-Employed & Freelancers', desc:'No employer withholding means you\'re responsible for your own taxes. Quarterly payments prevent a large April bill and the underpayment penalty.' },
  { icon:'🏢', title:'Business Owners & Partners', desc:'Pass-through income from S-Corps, partnerships, and LLCs is not withheld. Partners and S-Corp shareholders must make quarterly payments on their share.' },
  { icon:'🏠', title:'Rental Property Investors', desc:'Net rental income is taxable but not automatically withheld. Investors with multiple properties often owe significant quarterly estimates.' },
  { icon:'📈', title:'Investors with Capital Gains', desc:'Large capital gains from stock sales, crypto, or business dispositions often require mid-year estimated payments to avoid underpayment penalties.' },
  { icon:'💰', title:'High-Income W-2 Employees', desc:'Employees with side income, large bonuses, or RSU vesting events often have insufficient withholding and need supplemental quarterly payments.' },
  { icon:'🔄', title:'Business Structure Changes', desc:'Converting to an S-Corp, starting a partnership, or adding a new income stream changes your estimated tax obligation — we recalculate and adjust.' },
];

const deadlines = [
  { cls:'Q1', period:'Jan 1 – Mar 31', date:'Apr 15', desc:'First quarter estimated payment. Covers income earned January through March.' },
  { cls:'Q2', period:'Apr 1 – May 31', date:'Jun 16', desc:'Second quarter estimated payment. Covers income earned April and May.' },
  { cls:'Q3', period:'Jun 1 – Aug 31', date:'Sep 15', desc:'Third quarter estimated payment. Covers income earned June through August.' },
  { cls:'Q4', period:'Sep 1 – Dec 31', date:'Jan 15', desc:'Fourth quarter estimated payment. Covers September through December income.' },
];

const safeHarborOptions = [
  { title:'Option 1: 90% of Current Year Tax', desc:'Pay at least 90% of the current year\'s total tax liability through estimates and withholding, distributed across all four quarters.', tag:'Most common for growing income' },
  { title:'Option 2: 100% of Prior Year Tax', desc:'Pay an amount equal to your prior year\'s total tax liability. For simplicity, many clients prefer this — it\'s based on a known number.', tag:'Best for predictable income' },
  { title:'Option 3: 110% of Prior Year Tax (High Earners)', desc:'Taxpayers with AGI over $150,000 must pay 110% of the prior year tax (not 100%) to qualify for safe harbor protection.', tag:'Required if AGI > $150K' },
];

const calcMethods = [
  { emoji:'📊', title:'Annualized Income Installment Method', desc:'For businesses with uneven income (seasonal or project-based), we calculate estimates based on actual income earned each quarter — preventing overpayment in slow periods.' },
  { emoji:'🔢', title:'Prior Year Safe Harbor Calculation', desc:'Using the prior year\'s tax return as a base, we calculate the exact amount needed each quarter to guarantee safe harbor protection — eliminating all underpayment risk.' },
  { emoji:'📈', title:'Current Year Projection Method', desc:'We build a full-year income projection, estimate deductions and credits, and calculate the precise quarterly payment needed to hit exactly 90% of your current year liability.' },
  { emoji:'🔄', title:'Mid-Year Recalculation', desc:'When income spikes or drops significantly, we recalculate mid-year to prevent overpayment or catch up on underpayment — giving you the most accurate obligation at all times.' },
];

const faqs = [
  { q:'What happens if I miss a quarterly deadline?', a:'The IRS charges an underpayment penalty — currently around 8% annualized — on the amount you should have paid, from the due date through the date you actually paid. This is separate from the April filing deadline.' },
  { q:'How are quarterly estimates different from the April tax deadline?', a:'Quarterly estimated taxes are prepayments of your annual tax bill, due throughout the year. The April filing is when you reconcile — if you overpaid via estimates, you get a refund; if underpaid, you owe the balance plus potential penalties.' },
  { q:'Can I just pay my full tax bill in April to avoid the hassle?', a:'You can pay in April, but if your payments throughout the year were insufficient, the IRS will assess underpayment penalties regardless — even if you pay by April 15. Quarterly payments are required for most self-employed taxpayers.' },
  { q:'What if my income is highly variable or seasonal?', a:'The annualized income installment method lets you base each quarterly payment on actual income through that period — so you\'re not overpaying in Q1 when you earn most of your money in Q3.' },
  { q:'Do S-Corp shareholders need to make quarterly payments?', a:'Yes, in most cases. S-Corp distributions are not subject to withholding, and salary withholding often isn\'t sufficient to cover total tax on pass-through income. Most S-Corp shareholders need quarterly estimates.' },
  { q:'Does my state also require quarterly estimated payments?', a:'Most states with an income tax require estimated payments on a similar quarterly schedule. We calculate and track both federal and state obligations simultaneously to ensure you\'re fully covered.' },
];

const QuarterlyEstimates: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <div className="qe-page">
    <style>{styles}</style>

    {/* Hero */}
    <section className="qe-hero">
      <div className="qe-hero-blob1" /><div className="qe-hero-blob2" />
      <div className="qe-hero-inner">
        <div>
          {onBack && (
            <button type="button" className="qe-back-btn" onClick={onBack}>
              <span aria-hidden="true">←</span> Back to Tax Services
            </button>
          )}
          <motion.div initial={{opacity:0,scale:0.9}} animate={{opacity:1,scale:1}} transition={{duration:0.5}}>
            <div className="qe-hero-badge"><span className="qe-badge-dot" />Never miss a payment. Never pay a penalty.</div>
          </motion.div>
          <motion.h1 initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.1}}>
            Quarterly Estimates,<br /><span className="qe-gradient-text">Calculated Right.</span><br />Every Time.
          </motion.h1>
          <motion.p initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.6,delay:0.2}}>
            Underpayment penalties, cash flow surprises, and missed deadlines are entirely preventable. We calculate your exact quarterly obligation — down to the dollar — so you always pay the right amount at the right time.
          </motion.p>
          <motion.div className="qe-btn-group" initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{duration:0.5,delay:0.3}}>
            <button type="button" className="qe-btn-primary">Get My Estimates Calculated →</button>
            <button type="button" className="qe-btn-secondary">See How It Works</button>
          </motion.div>
        </div>
        <motion.div className="qe-hero-visual" initial={{opacity:0,x:40}} animate={{opacity:1,x:0}} transition={{duration:0.7,delay:0.2}}>
          <div className="qe-vis-header">
            <div className="qe-vis-title"><p>2025 Payment Schedule</p><p>Meridian Consulting LLC</p></div>
            <div className="qe-vis-icon">🗓️</div>
          </div>
          <div className="qe-schedule">
            {[
              {type:'paid',qCls:'paid',q:'Q1',title:'April 15, 2025 — Paid',amount:'$6,200'},
              {type:'paid',qCls:'paid',q:'Q2',title:'June 16, 2025 — Paid',amount:'$6,200'},
              {type:'due',qCls:'due',q:'Q3',title:'September 15, 2025 — Due',amount:'$7,100'},
              {type:'upcoming',qCls:'upcoming',q:'Q4',title:'January 15, 2026 — Upcoming',amount:'~$6,800'},
            ].map((item,i) => (
              <div className={`qe-schedule-item ${item.type}`} key={i}>
                <div className={`qe-q-badge ${item.qCls}`}>{item.q}</div>
                <div className="qe-sch-content">
                  <div className="qe-sch-title">{item.title}</div>
                </div>
                <div className={`qe-sch-amount ${item.type}`}>{item.amount}</div>
              </div>
            ))}
          </div>
          <div className="qe-vis-total">
            <span>2025 Total Estimated Payments</span>
            <span>$26,300 — $0 penalty risk</span>
          </div>
        </motion.div>
      </div>
    </section>

    {/* Stats */}
    <div className="qe-stats">
      <div className="qe-stats-grid">
        {[
          {num:'$0',label:'Underpayment Penalties for Our Clients',dark:false},
          {num:'4x/yr',label:'Proactive Recalculation Cadence',dark:false},
          {num:'Federal + State',label:'All Jurisdictions Covered',dark:true},
          {num:'99.7%',label:'On-Time Payment Rate',dark:true},
        ].map((s,i) => (
          <motion.div className="qe-stat" key={i} {...stagger(i)}>
            <div className={`qe-stat-num${s.dark?' dark':''}`}>{s.num}</div>
            <div className="qe-stat-label">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>

    {/* Who Needs Estimates */}
    <section className="qe-section qe-who">
      <div className="qe-container">
        <motion.div className="qe-section-header" {...fadeIn}>
          <span className="qe-label">Who This Applies To</span>
          <h2>Do You Need to Make Quarterly Estimated Tax Payments?</h2>
          <p>The IRS requires quarterly payments from most self-employed individuals and business owners. Find your situation below.</p>
        </motion.div>
        <div className="qe-who-grid">
          {whoNeeds.map((w,i) => (
            <motion.div className="qe-who-card" key={i} {...stagger(i)}>
              <span className="qe-who-icon">{w.icon}</span>
              <h3>{w.title}</h3>
              <p>{w.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* Deadline Calendar */}
    <section className="qe-section qe-calendar">
      <div className="qe-container">
        <div className="qe-cal-inner">
          <div className="qe-cal-glow1" /><div className="qe-cal-glow2" />
          <motion.div className="qe-cal-header" {...fadeIn}>
            <span className="qe-label">2025 Due Dates</span>
            <h2>The Four Quarterly Deadlines You Need to Know</h2>
            <p>Missing any of these triggers an IRS underpayment penalty — calculated from the missed due date, not just the April filing date.</p>
          </motion.div>
          <div className="qe-deadlines">
            {deadlines.map((d,i) => (
              <motion.div className="qe-deadline-card" key={i} {...stagger(i)}>
                <div className="qe-dl-quarter">{d.cls} Estimated Payment</div>
                <div className="qe-dl-period">{d.period}</div>
                <div className="qe-dl-date">{d.date}</div>
                <div className="qe-dl-desc">{d.desc}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* Safe Harbor */}
    <section className="qe-section qe-safeharbor">
      <div className="qe-container">
        <div className="qe-sh-inner">
          <motion.div className="qe-sh-left" {...fadeIn}>
            <span className="qe-label">Safe Harbor Rules</span>
            <h2>How to Guarantee You'll Never Owe a Penalty</h2>
            <p>The IRS provides "safe harbor" rules — if you meet any of these thresholds, you're completely protected from underpayment penalties, regardless of how much you owe in April.</p>
            <div className="qe-sh-options">
              {safeHarborOptions.map((opt,i) => (
                <div className="qe-sh-option" key={i}>
                  <h4>{opt.title}</h4>
                  <p>{opt.desc}</p>
                  <span className="qe-sh-tag">{opt.tag}</span>
                </div>
              ))}
            </div>
          </motion.div>
          <motion.div className="qe-sh-visual" initial={{opacity:0,x:30}} whileInView={{opacity:1,x:0}} viewport={{once:true}} transition={{duration:0.6,delay:0.2}}>
            <div className="qe-sh-vis-title">Without vs. With Quarterly Planning</div>
            <div className="qe-penalty-example">
              <p>❌ Without Proper Estimates</p>
              <p>You earn $180,000 net self-employment income and pay nothing until April 15. The IRS assesses ~$1,200–$2,400 in underpayment penalties on top of your balance due — plus interest from each missed quarterly deadline.</p>
            </div>
            <div className="qe-no-penalty">
              <p>✓ With BizServe Quarterly Estimates</p>
              <p>We calculate your exact safe harbor amount each quarter. You pay the right amount on time, every time. In April, you may owe a small balance or receive a refund — but never a penalty.</p>
            </div>
            <div className="qe-sh-checklist">
              {['Federal estimates calculated quarterly','State estimates for all applicable states','Payment reminders sent before each deadline','Mid-year recalculation if income changes','Prior year vs. current year comparison provided','Coordination with your annual tax return'].map((item,i) => (
                <div className="qe-sh-check" key={i}><div className="qe-sh-check-mark">✓</div>{item}</div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>

    {/* How We Calculate */}
    <section className="qe-section qe-calculate">
      <div className="qe-container">
        <motion.div className="qe-section-header" {...fadeIn}>
          <span className="qe-label">Our Methodology</span>
          <h2>Four Ways We Calculate Your Exact Quarterly Obligation</h2>
          <p>No guessing. No round numbers. We use the method that produces the most accurate and tax-efficient result for your specific situation.</p>
        </motion.div>
        <div className="qe-calc-grid">
          {calcMethods.map((m,i) => (
            <motion.div className="qe-calc-card" key={i} {...stagger(i)}>
              <span className="qe-calc-emoji">{m.emoji}</span>
              <div>
                <h3>{m.title}</h3>
                <p>{m.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="qe-section qe-faq">
      <div className="qe-container">
        <motion.div className="qe-section-header" {...fadeIn}>
          <span className="qe-label">Common Questions</span>
          <h2>Everything You Need to Know About Quarterly Taxes</h2>
          <p>Questions? Reach out — we respond within one business day and offer a free initial consultation.</p>
        </motion.div>
        <div className="qe-faq-grid">
          {faqs.map((f,i) => (
            <motion.div className="qe-faq-item" key={i} {...stagger(i)}>
              <div className="qe-faq-q"><div className="qe-faq-q-icon">?</div>{f.q}</div>
              <div className="qe-faq-a">{f.a}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="qe-cta">
      <div className="qe-cta-inner">
        <div className="qe-cta-glow1" /><div className="qe-cta-glow2" />
        <motion.h2 {...fadeIn}>Stop Guessing. Start Paying Exactly What You Owe.</motion.h2>
        <motion.p {...{...fadeIn,transition:{duration:0.55,delay:0.1}}}>
          Let us calculate your quarterly estimates with precision — protecting you from penalties, smoothing your cash flow, and eliminating the April surprise.
        </motion.p>
        <motion.div className="qe-cta-btns" {...{...fadeIn,transition:{duration:0.5,delay:0.2}}}>
          <button type="button" className="qe-cta-primary">Get My Estimates →</button>
          <button type="button" className="qe-cta-secondary">Schedule a Free Call</button>
        </motion.div>
        <motion.div className="qe-cta-badges" {...{...fadeIn,transition:{duration:0.5,delay:0.3}}}>
          {['Federal & state included','Zero penalty guarantee','Quarterly recalculation','Transparent flat pricing'].map((b,i) => (
            <div className="qe-cta-badge" key={i}><span className="qe-cta-badge-check">✓</span>{b}</div>
          ))}
        </motion.div>
      </div>
    </section>
  </div>
);

export default QuarterlyEstimates;
